import axios from "axios";

export const fetchMealData = async (limit = 10) => {
  try {
    const accessToken = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).accessToken
      : null;

    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/mealEmp`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: { limit },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Fetch Meal Data API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};

export const orderMeal = async (orderData) => {
  try {
    const accessToken = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).accessToken
      : null;

    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/orderMeal`,
      orderData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Order Meal API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};
